// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const FIND_AND_REPLACE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.FIND_AND_REPLACE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      selectedColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          allowMissingColumn: false,
          validationOptions: {
            allowedLeafTypes: [
              LeafType.TEXT
            ],
            listType: ColumnTypeValidationFlag.NOT_ALLOWED,
            nullableType: ColumnTypeValidationFlag.ALLOWED,
            maybeTextType: ColumnTypeValidationFlag.NOT_ALLOWED,
            strictLeafType: true
          }
        }
      },
      findAndReplaceOptions: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'findAndReplaceType',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              replacementString: {
                kind: 'string',
                required: true
              },
              matchAllOccurrences: {
                kind: 'boolean',
                required: true
              },
              findAndReplaceType: {
                kind: 'string',
                required: true,
                value: 'LITERAL'
              },
              literalString: {
                kind: 'string',
                required: true
              },
              matchWholeWord: {
                kind: 'boolean',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              replacementString: {
                kind: 'string',
                required: true
              },
              matchAllOccurrences: {
                kind: 'boolean',
                required: true
              },
              findAndReplaceType: {
                kind: 'string',
                required: true,
                value: 'REGEX'
              },
              patternString: {
                kind: 'string',
                required: true
              }
            }
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
